import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home.vue'
import List from '@/components/list.vue'
import Detail from '@/components/detail.vue'
import ShopCart from '@/components/shopCart.vue'

import Register from '@/components/register.vue'
import Login from '@/components/login.vue'

import Buyer from '@/components/buyer.vue'
import TopUp from '@/components/buyer/topUp.vue'
import ChangeOfSeller from '@/components/buyer/changeOfSeller.vue'
import Border from '@/components/buyer/order.vue'
import Bservice from '@/components/buyer/service.vue'
import Bwork from '@/components/buyer/work.vue'
import Money from '@/components/buyer/money.vue'
import Company from '@/components/buyer/company.vue'
import Bank from '@/components/buyer/bank.vue'
import Withdraw from '@/components/buyer/withdraw.vue'
import Address from '@/components/buyer/address.vue'
import Invoice from '@/components/buyer/invoice.vue'
import SaveInfo from '@/components/buyer/saveInfo.vue'
import Updatepsd from '@/components/buyer/updatepsd.vue'
import StockTaking from '@/components/buyer/stockTaking.vue'
import Moneylist from '@/components/buyer/moneylist.vue'
import Bill from '@/components/buyer/bill.vue'
import Userlist from '@/components/buyer/userlist.vue'
import Bhome from '@/components/buyer/home.vue'
import Shops from '@/components/buyer/shops.vue'
import Shoplist from '@/components/buyer/shoplist.vue'
import Shoprank from '@/components/buyer/shoprank.vue'
import WarehouseIndex from '@/components/buyer/warehouse/index.vue'
import WarehouseApply from '@/components/buyer/warehouse/apply.vue'
import WarehouseDepositLog from '@/components/buyer/warehouse/depositLog.vue'
import WarehouseEntry from '@/components/buyer/warehouse/entry.vue'
import WarehousePos from '@/components/buyer/warehouse/pos.vue'
import WarehouseGoods from '@/components/buyer/warehouse/goods.vue'
import WarehouseBuyout from '@/components/buyer/warehouse/buyout.vue'
import WarehouseSale from '@/components/buyer/warehouse/sale.vue'
import WarehouseExit from '@/components/buyer/warehouse/exit.vue'
import WarehousePromotion from '@/components/buyer/warehouse/promotion.vue'
import WarehouseStocktaking from '@/components/buyer/warehouse/stocktaking.vue'

import Seller from '@/components/seller.vue'
import Channel from '@/components/seller/channel.vue'
import Storekeeper from '@/components/seller/storekeeper.vue'
import ShippingCost from '@/components/seller/shippingCost.vue'
import Discount from '@/components/seller/discount.vue'
import Sorder from '@/components/seller/order.vue'
import Service from '@/components/seller/service.vue'
import Swork from '@/components/seller/work.vue'
import Smoneylist from '@/components/seller/moneylist.vue'
import Prepay from '@/components/seller/prepay.vue'
import Kuaidizs from '@/components/seller/kuaidizs.vue'
import Notice from '@/components/seller/notice.vue'
import Shome from '@/components/seller/home.vue'
import SellerWarehouseIndex from '@/components/seller/warehouse/index.vue'
import SellerWarehouseEntry from '@/components/seller/warehouse/entry.vue'
import SellerWarehouseRecord from '@/components/seller/warehouse/record.vue'
import SellerWarehouseSettle from '@/components/seller/warehouse/settle.vue'
import SellerWarehouseStock from '@/components/seller/warehouse/stock.vue'
import SellerWarehouseBuyout from '@/components/seller/warehouse/buyout.vue'
import SellerWarehouseExit from '@/components/seller/warehouse/exit.vue'
import SellerWarehouseAddress from '@/components/seller/warehouse/address.vue'

import Jaccount from '@/components/jushuitan/account.vue'
import Jconfig from '@/components/jushuitan/config.vue'
import Jstock from '@/components/jushuitan/stock.vue'
import Jorder from '@/components/jushuitan/order.vue'
import JorderSend from '@/components/jushuitan/orderSend.vue'
import JafterSale from '@/components/jushuitan/after_sale.vue'

import Pshop from '@/components/pdd/shop.vue'
import Plaunch from '@/components/pdd/launch.vue'
import Plog from '@/components/pdd/log.vue'
import Pgoods from '@/components/pdd/goods.vue'
import Pskulog from '@/components/pdd/skulog.vue'
import Porder from '@/components/pdd/order.vue'
import Pservice from '@/components/pdd/service.vue'

import StoreConfig from '@/components/storeConfig.vue'
import BasicConfig from '@/components/StoreConfig/basicConfig.vue'
import TabsConfig from '@/components/StoreConfig/tabsConfig.vue'
import BatchTabsConfig from '@/components/StoreConfig/batchTabsConfig.vue'
import MSetup from '@/components/StoreConfig/detailed/mSetup.vue'
import ChannelOrders from '@/components/StoreConfig/detailed/channelOrders.vue'
import ChannelStock from '@/components/StoreConfig/detailed/channelStock.vue'
import BackupChannelStock from '@/components/StoreConfig/detailed/backupChannelStock.vue'
import StockDisplayRule from '@/components/StoreConfig/detailed/stockDisplayRule.vue'
import ManualAssignRule from '@/components/StoreConfig/detailed/manualAssignRule.vue'
import FixedPriceChannelRule from '@/components/StoreConfig/detailed/fixedPriceChannelRule.vue'
import SafetyStockPriceRule from '@/components/StoreConfig/detailed/safetyStockPriceRule.vue'
import OrderAutoMatchRule from '@/components/StoreConfig/detailed/orderAutoMatchRule.vue'
import OneClickListingRule from '@/components/StoreConfig/detailed/oneClickListingRule.vue'
import ListingSizeDetail from '@/components/StoreConfig/detailed/listingSizeDetail.vue'
import BlacklistChannel from '@/components/StoreConfig/detailed/blacklistChannel.vue'
import StorePddGoods from '@/components/StoreConfig/pddGoods.vue'

import MiniprogramAccount from '@/components/StoreConfig/miniprogram/account.vue'
import MiniprogramGoods from '@/components/StoreConfig/miniprogram/goods.vue'
import MiniprogramOrder from '@/components/StoreConfig/miniprogram/order.vue'
import MiniprogramService from '@/components/StoreConfig/miniprogram/service.vue'
import MiniprogramDist from '@/components/StoreConfig/miniprogram/dist.vue'
import MiniprogramDistMembers from '@/components/StoreConfig/miniprogram/distMembers.vue'
import MiniprogramWithdraw from '@/components/StoreConfig/miniprogram/withdraw.vue'
import MiniprogramComments from '@/components/StoreConfig/miniprogram/comments.vue'
import MiniprogramTabsConfig from '@/components/StoreConfig/miniprogramTabsConfig.vue'
import TaobaoAccount from '@/components/StoreConfig/taobao/account.vue'
import TaobaoGoods from '@/components/StoreConfig/taobao/goods.vue'
import TaobaoOrder from '@/components/StoreConfig/taobao/order.vue'
import TaobaoService from '@/components/StoreConfig/taobao/service.vue'
import TaobaoTabsConfig from '@/components/StoreConfig/taobaoTabsConfig.vue'

Vue.use(Router)

const router = new Router({
	routes: [{
			path: '/',
			redirect: '/home'
		},
		{
			path: '/home',
			name: 'Home',
			component: Home
		},{
			path: '/register',
			name: 'Register',
			component: Register
		},{
			path: '/login',
			name: 'Login',
			component: Login
		},{
			path: '/list',
			name: 'List',
			component: List
		},{
			path: '/detail',
			name: 'Detail',
			component: Detail
		},{
			path: '/shopCart',
			name: 'ShopCart',
			component: ShopCart
		},{
			path: '/buyer',
			name: 'Buyer',
			component: Buyer,
			children: [{
				path: '/buyer',
				redirect: '/buyer/home'
			},{
				path: '/buyer/home',
				component: Bhome,
			},{
				path: '/buyer/topUp',
				component: TopUp,
			},{
				path: '/buyer/changeOfSeller',
				component: ChangeOfSeller,
			},{
				path: '/buyer/order/order',
				name: 'border',
				component: Border,
			},{
				path: '/buyer/order/service',
				component: Bservice,
			},{
				path: '/buyer/order/work',
				component: Bwork,
			}, {
				path: '/buyer/money',
				component: Money,
			},{
				path: '/buyer/company',
				component: Company,
			},{
				path: '/buyer/bank',
				component: Bank,
			},{
				path: '/buyer/withdraw',
				component: Withdraw,
			},{
				path: '/buyer/address',
				component: Address,
			},{
				path: '/buyer/invoice',
				component: Invoice,
			},{
				path: '/buyer/saveInfo',
				component: SaveInfo,
			},{
				path: '/buyer/updatepsd',
				component: Updatepsd,
			},{
				path: '/buyer/inventory/stockTaking',
				component: StockTaking,
			},{
				path: '/buyer/moneys/userlist',
				component: Userlist,
			},{
				path: '/buyer/moneys/moneylist',
				component: Moneylist,
			},{
				path: '/buyer/moneys/bill',
				component: Bill,
			},{
				path: '/buyer/shops',
				component: Shops,
			},{
				path: '/buyer/shoplist',
				component: Shoplist,
			},{
				path: '/buyer/pdd/shop',
				component: Pshop,
			},{
				path: '/buyer/pdd/launch',
				component: Plaunch,
			},{
				path: '/buyer/pdd/log',
				component: Plog,
			},{
				path: '/buyer/pdd/goods',
				component: Pgoods,
			},{
				path: '/buyer/pdd/skulog',
				component: Pskulog,
			},{
				path: '/buyer/pdd/order',
				component: Porder,
			},{
				path: '/buyer/pdd/service',
				component: Pservice,
			},{
				path: '/buyer/taobao/shop',
				component: TaobaoAccount,
			},{
				path: '/buyer/miniprogram/shop',
				component: MiniprogramAccount,
			},{
				path: '/buyer/miniprogram/goods',
				component: MiniprogramGoods,
			},{
				path: '/buyer/miniprogram/order',
				component: MiniprogramOrder,
			},{
				path: '/buyer/miniprogram/service',
				component: MiniprogramService,
			},{
				path: '/buyer/miniprogram/dist',
				component: MiniprogramDist,
			},{
				path: '/buyer/miniprogram/distMembers',
				component: MiniprogramDistMembers,
			},{
				path: '/buyer/miniprogram/withdraw',
				component: MiniprogramWithdraw,
			},{
				path: '/buyer/miniprogram/comments',
				component: MiniprogramComments,
			},{
				path: '/buyer/shoprank',
				component: Shoprank,
			},{
				path: '/buyer/warehouse/index',
				component: WarehouseIndex,
			},{
				path: '/buyer/warehouse/apply',
				component: WarehouseApply,
			},{
				path: '/buyer/warehouse/deposit_log',
				component: WarehouseDepositLog,
			},{
				path: '/buyer/warehouse/entry',
				component: WarehouseEntry,
			},{
				path: '/buyer/warehouse/pos',
				component: WarehousePos,
			},{
				path: '/buyer/warehouse/goods',
				component: WarehouseGoods,
			},{
				path: '/buyer/warehouse/buyout',
				component: WarehouseBuyout,
			},{
				path: '/buyer/warehouse/sale',
				component: WarehouseSale,
			},{
				path: '/buyer/warehouse/exit',
				component: WarehouseExit,
			},{
				path: '/buyer/warehouse/promotion',
				component: WarehousePromotion,
			},{
				path: '/buyer/warehouse/stocktaking',
				component: WarehouseStocktaking,
			}]
		},{
			path: '/seller',
			name: 'Seller',
			component: Seller,
			children: [{
				path: '/seller',
				redirect: '/seller/home'
			},{
				path: '/seller/home',
				component: Shome,
			},{
				path: '/seller/management/channel',
				component: Channel,
			},{
				path: '/seller/management/channel/storekeeper',
				component: Storekeeper,
			},{
				path: '/seller/management/shippingCost',
				component: ShippingCost,
			},{
				path: '/seller/management/discount',
				component: Discount,
			},{
				path: '/seller/order/order',
				name: 'sorder',
				component: Sorder,
			},{
				path: '/seller/order/service',
				component: Service,
			},{
				path: '/seller/order/work',
				component: Swork,
			},{
				path: '/seller/moneys/moneylist',
				component: Smoneylist,
			},{
				path: '/seller/moneys/prepay',
				component: Prepay,
			},{
				path: '/seller/warehouse/index',
				component: SellerWarehouseIndex,
			},{
				path: '/seller/warehouse/entry',
				component: SellerWarehouseEntry,
			},{
				path: '/seller/warehouse/record',
				component: SellerWarehouseRecord,
			},{
				path: '/seller/warehouse/settle',
				component: SellerWarehouseSettle,
			},{
				path: '/seller/warehouse/stock',
				component: SellerWarehouseStock,
			},{
				path: '/seller/warehouse/buyout',
				component: SellerWarehouseBuyout,
			},{
				path: '/seller/warehouse/exit',
				component: SellerWarehouseExit,
			},{
				path: '/seller/warehouse/withdraw',
				redirect: { path: '/seller/warehouse/settle', query: { tab: 'withdraw' } },
			},{
				path: '/seller/warehouse/address',
				component: SellerWarehouseAddress,
			},{
				path: '/seller/kuaidizs',
				component: Kuaidizs,
			},{
				path: '/seller/notice',
				component: Notice,
			},{
				path: "/seller/erp/jushuitan/account",
				component: Jaccount
			},{
				path: "/seller/erp/jushuitan/config",
				component: Jconfig
			},{
				path: "/seller/erp/jushuitan/stock",
				component: Jstock
			},{
				path: "/seller/erp/jushuitan/order",
				component: Jorder
			},{
				path: "/seller/erp/jushuitan/orderSend",
				component: JorderSend
			},{
				path: "/seller/erp/jushuitan/afterSale",
				component: JafterSale
			}]
		},{
			path: '/storeConfig',
			name: 'StoreConfig',
			component: StoreConfig,
			children: [{
				path: '/storeConfig',
				redirect: '/StoreConfig/basicConfig'
			},{
				path: '/StoreConfig/basicConfig',
				component: BasicConfig
			},{
				path: '/StoreConfig/pddGoods',
				component: StorePddGoods
			},{
				path: '/StoreConfig/pddGoods/channel/:productId',
				component: StorePddGoods
			},{
				path: '/StoreConfig/pddGoods/sku/:productId',
				component: StorePddGoods
			},{
				path: '/StoreConfig/pdd/order',
				component: Porder,
			},{
				path: '/StoreConfig/pdd/service',
				component: Pservice,
			},{
				path: '/StoreConfig/pdd/launch',
				component: Plaunch,
			},{
				path: '/StoreConfig/pdd/log',
				component: Plog,
			},{
				path: '/StoreConfig/taobao/account',
				component: TaobaoAccount,
			},{
				path: '/StoreConfig/taobao/goods',
				component: TaobaoGoods,
			},{
				path: '/StoreConfig/taobao/order',
				component: TaobaoOrder,
			},{
				path: '/StoreConfig/taobao/service',
				component: TaobaoService,
			},{
				path: '/StoreConfig/taobao/tabsConfig',
				name: 'TaobaoTabsConfig',
				component: TaobaoTabsConfig,
				children: [{
					path: '/StoreConfig/taobao/tabsConfig',
					redirect: '/StoreConfig/taobao/detailed/mSetup',
				},{
					path: '/StoreConfig/taobao/detailed/mSetup',
					component: MSetup,
				},{
					path: '/StoreConfig/taobao/detailed/channelOrders',
					component: ChannelOrders,
				},{
					path: '/StoreConfig/taobao/detailed/channelStock',
					component: ChannelStock,
				},{
					path: '/StoreConfig/taobao/detailed/backupChannelStock',
					component: BackupChannelStock,
				},{
					path: '/StoreConfig/taobao/detailed/stockDisplayRule',
					component: StockDisplayRule,
				},{
					path: '/StoreConfig/taobao/detailed/manualAssignRule',
					component: ManualAssignRule,
				},{
					path: '/StoreConfig/taobao/detailed/fixedPriceChannelRule',
					component: FixedPriceChannelRule,
				},{
					path: '/StoreConfig/taobao/detailed/safetyStockPriceRule',
					component: SafetyStockPriceRule,
				},{
					path: '/StoreConfig/taobao/detailed/orderAutoMatchRule',
					component: OrderAutoMatchRule,
				},{
					path: '/StoreConfig/taobao/detailed/blacklistChannel',
					component: BlacklistChannel,
				}]
			},{
				path: '/StoreConfig/miniprogram/config',
				redirect: '/StoreConfig/miniprogram/account',
			},{
				path: '/StoreConfig/miniprogram/account',
				component: MiniprogramAccount,
			},{
				path: '/StoreConfig/miniprogram/goods',
				component: MiniprogramGoods,
			},{
				path: '/StoreConfig/miniprogram/order',
				component: MiniprogramOrder,
			},{
				path: '/StoreConfig/miniprogram/service',
				component: MiniprogramService,
			},{
				path: '/StoreConfig/miniprogram/dist',
				component: MiniprogramDist,
			},{
				path: '/StoreConfig/miniprogram/distMembers',
				component: MiniprogramDistMembers,
			},{
				path: '/StoreConfig/miniprogram/withdraw',
				component: MiniprogramWithdraw,
			},{
				path: '/StoreConfig/miniprogram/comments',
				component: MiniprogramComments,
			},{
				path: '/StoreConfig/miniprogram/tabsConfig',
				name: 'MiniprogramTabsConfig',
				component: MiniprogramTabsConfig,
				children: [{
					path: '/StoreConfig/miniprogram/tabsConfig',
					redirect: '/StoreConfig/miniprogram/detailed/mSetup',
				},{
					path: '/StoreConfig/miniprogram/detailed/mSetup',
					component: MSetup,
				},{
					path: '/StoreConfig/miniprogram/detailed/channelOrders',
					component: ChannelOrders,
				},{
					path: '/StoreConfig/miniprogram/detailed/channelStock',
					component: ChannelStock,
				},{
					path: '/StoreConfig/miniprogram/detailed/backupChannelStock',
					component: BackupChannelStock,
				},{
					path: '/StoreConfig/miniprogram/detailed/stockDisplayRule',
					component: StockDisplayRule,
				},{
					path: '/StoreConfig/miniprogram/detailed/manualAssignRule',
					component: ManualAssignRule,
				},{
					path: '/StoreConfig/miniprogram/detailed/fixedPriceChannelRule',
					component: FixedPriceChannelRule,
				},{
					path: '/StoreConfig/miniprogram/detailed/safetyStockPriceRule',
					component: SafetyStockPriceRule,
				},{
					path: '/StoreConfig/miniprogram/detailed/orderAutoMatchRule',
					component: OrderAutoMatchRule,
				},{
					path: '/StoreConfig/miniprogram/detailed/blacklistChannel',
					component: BlacklistChannel,
				}]
			},{
				path: '/StoreConfig/tabsConfig',
				name: 'TabsConfig',
				component: TabsConfig,
				children: [{
					path: '/StoreConfig/tabsConfig',
					redirect: '/StoreConfig/detailed/mSetup',
				},{
					path: '/StoreConfig/detailed/mSetup',
					component: MSetup,
				},{
					path: '/StoreConfig/detailed/channelOrders',
					component: ChannelOrders,
				},{
					path: '/StoreConfig/detailed/channelStock',
					component: ChannelStock,
				},{
					path: '/StoreConfig/detailed/backupChannelStock',
					component: BackupChannelStock,
				},{
					path: '/StoreConfig/detailed/stockDisplayRule',
					component: StockDisplayRule,
				},{
					path: '/StoreConfig/detailed/manualAssignRule',
					component: ManualAssignRule,
				},{
					path: '/StoreConfig/detailed/fixedPriceChannelRule',
					component: FixedPriceChannelRule,
				},{
					path: '/StoreConfig/detailed/safetyStockPriceRule',
					component: SafetyStockPriceRule,
				},{
					path: '/StoreConfig/detailed/orderAutoMatchRule',
					component: OrderAutoMatchRule,
				},{
					path: '/StoreConfig/detailed/oneClickListingRule',
					component: OneClickListingRule,
				},{
					path: '/StoreConfig/detailed/listingSizeDetail',
					component: ListingSizeDetail,
				},{
					path: '/StoreConfig/detailed/blacklistChannel',
					component: BlacklistChannel,
				}]
			},{
				path: '/StoreConfig/batchConfig',
				name: 'BatchTabsConfig',
				component: BatchTabsConfig,
				redirect: '/StoreConfig/batchDetailed/mSetup',
				children: [{
					path: '/StoreConfig/batchDetailed/mSetup',
					component: MSetup,
				},{
					path: '/StoreConfig/batchDetailed/channelOrders',
					component: ChannelOrders,
				},{
					path: '/StoreConfig/batchDetailed/channelStock',
					component: ChannelStock,
				},{
					path: '/StoreConfig/batchDetailed/backupChannelStock',
					component: BackupChannelStock,
				},{
					path: '/StoreConfig/batchDetailed/stockDisplayRule',
					component: StockDisplayRule,
				},{
					path: '/StoreConfig/batchDetailed/manualAssignRule',
					component: ManualAssignRule,
				},{
					path: '/StoreConfig/batchDetailed/fixedPriceChannelRule',
					component: FixedPriceChannelRule,
				},{
					path: '/StoreConfig/batchDetailed/safetyStockPriceRule',
					component: SafetyStockPriceRule,
				},{
					path: '/StoreConfig/batchDetailed/orderAutoMatchRule',
					component: OrderAutoMatchRule,
				},{
					path: '/StoreConfig/batchDetailed/oneClickListingRule',
					component: OneClickListingRule,
				},{
					path: '/StoreConfig/batchDetailed/blacklistChannel',
					component: BlacklistChannel,
				}]
			}]
		}
	]
})
router.beforeEach((to, from, next) => {
  // 处理 admin 端跳转携带的 token（URL ?token=xxx → 写入 cookie）
  const tokenParams = new URLSearchParams(window.location.search)
  const urlToken = tokenParams.get('token')
  if (urlToken) {
    Vue.$cookies.set('token', urlToken, 60 * 60 * 24)
    const cleanUrl = new URL(window.location.href)
    cleanUrl.searchParams.delete('token')
    window.history.replaceState({}, '', cleanUrl.toString())
  }
  const buyerPddRedirectMap = {
    '/buyer/pdd/launch': '/StoreConfig/pdd/launch',
    '/buyer/pdd/log': '/StoreConfig/pdd/log',
    '/buyer/pdd/order': '/StoreConfig/pdd/order',
    '/buyer/pdd/service': '/StoreConfig/pdd/service',
  }
  if (buyerPddRedirectMap[to.path]) {
    next(buyerPddRedirectMap[to.path])
    return
  }
  const buyerMiniprogramRedirectMap = {
    '/buyer/miniprogram/goods': '/StoreConfig/miniprogram/goods',
    '/buyer/miniprogram/order': '/StoreConfig/miniprogram/order',
    '/buyer/miniprogram/service': '/StoreConfig/miniprogram/service',
    '/buyer/miniprogram/dist': '/StoreConfig/miniprogram/dist',
    '/buyer/miniprogram/distMembers': '/StoreConfig/miniprogram/distMembers',
    '/buyer/miniprogram/withdraw': '/StoreConfig/miniprogram/withdraw',
    '/buyer/miniprogram/comments': '/StoreConfig/miniprogram/comments',
  }
  if (buyerMiniprogramRedirectMap[to.path]) {
    next(buyerMiniprogramRedirectMap[to.path])
    return
  }
  // 其余 buyer/pdd 旧链接统一跳转到拼多多店铺
  if (/^\/buyer\/pdd\b/.test(to.path)) {
	const url = router.resolve({
		name: "StoreConfig"
	});
	window.open(url.href, "_blank");
	next(false);
	return
  }
  // buyer/miniprogram 统一新开小程序店铺工作区
  if (/^\/buyer\/miniprogram\b/.test(to.path)) {
	const url = router.resolve({
		path: '/StoreConfig/miniprogram/account',
	});
	window.open(url.href, "_blank");
	next(false);
	return
  }
  // buyer/taobao 统一新开淘宝店铺工作区
  if (/^\/buyer\/taobao\b/.test(to.path)) {
	const url = router.resolve({
		path: '/StoreConfig/taobao/account',
	});
	window.open(url.href, "_blank");
	next(false);
	return
  } else {
    next();
  }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js